export const FINANCIAL_SITUATION_FIELD_NAME = 'Your financial situation';
export const MONTHLY_INCOME_FIELD_NAME = 'Average monthly income';
export const MONTHLY_PAYMENT_FIELD_NAME = 'Average amount of monthly payment';
export const DEBT_INFO_QA_LABEL = 'debtInfo';
export const OFW_RELATIONSHIP_FIELD_NAME =
  'I receive money from an OFW (Overseas Filipino Worker)';
export const OFW_RELATIONSHIP_QA_LABEL = 'ofw-relationship-radio';
export const OFW_RELATIONSHIP_QUESTION_FIELD_NAME =
  'What is your relationship with the OFW?';
export const OFW_COUNTRY_OF_WORK_FIELD_NAME = 'Which country do they work in?';
export const OFW_INCOME_AMOUNT_FIELD_NAME = 'How much do they send in a month?';
export const OFW_INCOME_FREQUENCY_FIELD_NAME = 'How often do they send money?';
